import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  fieldId: null,
  isLoading: false,
  error: null,
  success: null,
};

const rastersSlice = createSlice({
  name: "rasters",
  initialState,
  reducers: {
    fetchRastersStart(state, action) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
      state.fieldId = action.payload?.field_id ?? null;
      state.data = {
        data: [],
        count: 0,
        total: 0,
        limit: 100,
        offset: 0,
        latestSurvey: null,
      };
    },
    fetchRastersSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.fieldId = action.payload?.field_id ?? state.fieldId;
      state.success = true;
    },
    fetchRastersFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const {
  fetchRastersStart,
  fetchRastersSuccess,
  fetchRastersFailure,
} = rastersSlice.actions;
export default rastersSlice.reducer;
